import Icon from 'components/base/Icon';
import Text, { Inline } from 'components/base/Text';
import { Flex } from 'components/base/layout-components';
import { Tooltip } from '@material-ui/core';
import { HeaderTooltipContent } from './Permissions.service';
import { useHistory } from 'react-router';
import { LBButton, LBXIcon } from '@linearb/buzz';

const Header = ({ selectedAccounts = [] }) => {
  const { goBack } = useHistory();
  const { length: numOfAccounts } = selectedAccounts;
  const disableTooltip = numOfAccounts <= 1;
  const { name = '', invitee_name = '' } = selectedAccounts[0] || {};
  const userTitle =
    numOfAccounts > 1 ? `${numOfAccounts} Users` : name || invitee_name;
  return (
    <Flex width='100%' justify='space-between' items='center'>
      <Flex>
        <Icon name='usermerge' size='medium' color='shuttleGray' />
        <Flex>
          <Text size='x-x-large' weight='400' pl='1rem'>
            Edit User Permissions -
          </Text>
          <Tooltip
            title={<HeaderTooltipContent accounts={selectedAccounts} />}
            disableHoverListener={disableTooltip}
            interactive
          >
            <Inline pl='0.5rem' size='x-x-large' weight='500'>
              {userTitle}
            </Inline>
          </Tooltip>
        </Flex>
      </Flex>
      <LBButton
        variant='ghost'
        data-testid='close-icon'
        onClick={goBack}
        size='icon'
      >
        <LBXIcon />
      </LBButton>
    </Flex>
  );
};

export default Header;
